import { AlertTriangle } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';
import { CyberDepositIcon } from '@/components/ui/icons/wallet-icons';

interface InsufficientCustodialBannerProps {
    shortfall: number;
    onDeposit: () => void;
}

const InsufficientCustodialBanner: React.FC<
    InsufficientCustodialBannerProps
> = ({ shortfall, onDeposit }) => {
    return (
        <div
            role="status"
            className="custodial-shortfall-pulse flex items-center justify-between gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 px-3 py-2"
        >
            <div className="flex items-center gap-2">
                <AlertTriangle size={14} className="shrink-0 text-amber-400" />
                <div>
                    <p className="text-[10px] font-semibold text-amber-400">
                        Insufficient Quick trade balance
                    </p>
                    <p className="text-[10px] text-muted-foreground">
                        Need{' '}
                        <span className="font-mono tabular-nums text-amber-400">
                            ${shortfall.toFixed(2)}
                        </span>{' '}
                        more
                    </p>
                </div>
            </div>
            <Button
                size="sm"
                onClick={onDeposit}
                className="group shrink-0 gap-1"
            >
                <CyberDepositIcon size={18} />
                Deposit
            </Button>
        </div>
    );
};

export default InsufficientCustodialBanner;
